import styles from './Badge.module.scss'

const Badge = ({ text }) => {
  return <span className={styles.base}>{text}</span>
}

export default Badge
